export function buildUniquePrefixList<T>(
  items: T[],
  extractPrefix: (item: T) => string | null
): string[] {
  return [
    ...new Set(items.map(extractPrefix).filter((prefix): prefix is string => prefix !== null)),
  ];
}
